// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1Wf9H","visuallyhidden":"O8GQ8","hide-text":"_1KAIx","center":"_2xzsk","noprint":"_3Cits","subheading":"_38ZrT"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-subheading/styles/feature.scss
 ** module id = 137
 ** module chunks = 2
 **/